export const MockMenuData = [
    {
        id: 1,
        title: "Digital asset",
        path: "/setting/digital-asset"
    },
    {
        id: 2,
        title: "Submission",
        path: "/setting/submission"
    },
    {
        id: 3,
        title: "Alert configuration",
        path: "/setting/alert-configuration"
    },
    {
        id: 4,
        title: "Application",
        path: "/setting/application"
    },
    {
        id: 5,
        title: "Analytics",
        path: "/setting/analytics"
    },
    {
        id: 6,
        title: "Attachments",
        path: "/setting/attachments"
    },
]